import {ErrorRouteNames} from '@client/routes/errors';
import {Route, NavigationGuardNext} from 'vue-router';
import {ClientWindow} from '@client/custom-window';

declare let window: ClientWindow;

const maintenance = (to: Route, _from: Route, next: NavigationGuardNext): void => {
  if (to.name !== ErrorRouteNames.MaintenancePage && window.rwOptions.IS_UNDER_MAINTENANCE) {
    // eslint-disable-next-line callback-return
    next({name: ErrorRouteNames.MaintenancePage});
  } else {
    // eslint-disable-next-line callback-return
    next();
  }
};

export default maintenance;
